import React from "react";

import { ScreenFooter, ScreenHeader, ScreenBody } from "./index.js";

const StudioScreen = function(props) {
  let { screenHeader, screenBody, screenFooter } = parseChildren(
    props.children,
  );

  let header = screenHeader || <ScreenHeader />;

  let body = screenBody || <ScreenBody />;

  let footer = screenFooter || <ScreenFooter />;

  let style = props.style || {};

  return (
    <div>
      {header}

      {body}

      {footer}
    </div>
  );
};

function parseChildren(children) {
  let screenHeader = null;
  let screenBody = null;
  let screenFooter = null;
  let otherElements = [];

  // Match on component identity, not component.type.name: the minifier renames
  // the ScreenHeader/ScreenBody/ScreenFooter functions, so their runtime .name
  // is a mangled letter that never equals these labels. Comparing against the
  // imported references is minification-proof.
  React.Children.forEach(children, (component) => {
    switch (component && component.type) {
      case ScreenHeader:
        screenHeader = component;
        break;
      case ScreenBody:
        screenBody = component;
        break;
      case ScreenFooter:
        screenFooter = component;
        break;
      default:
        otherElements.push(component);
        break;
    }
  });

  return {
    screenHeader: screenHeader,
    screenBody: screenBody,
    screenFooter: screenFooter,
    otherElements: otherElements,
  };
}

export default StudioScreen;
